<template>
  <div class="footer">
    <h2>Děkujeme</h2>
  </div>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style lang="scss" scoped>
  .footer {
    display: flex;
    justify-content: center;
    padding: 20px 0 40px;
  }
</style>
